import { useTranslation } from 'react-i18next'
import { Palette, Zap, Volume2, Eye } from 'lucide-react'
import Modal from '../ui/Modal'
import GlassCard from '../ui/GlassCard'
import { useStore } from '../../store/useStore'

const SettingsModal = () => {
  const { t } = useTranslation()
  const { 
    preferences, 
    setPreferences,
    sceneSettings,
    setSceneSettings,
  } = useStore()

  const toggleSetting = (key) => {
    setPreferences({ [key]: !preferences[key] })
  }

  const updateSceneSetting = (key, value) => {
    setSceneSettings({ [key]: value })
  }

  return (
    <Modal name="settings" title="Paramètres" size="lg">
      <div className="space-y-6">
        {/* Appearance Settings */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 flex items-center space-x-2">
            <Palette className="w-5 h-5 text-primary-400" />
            <span>Apparence</span>
          </h3>
          <div className="space-y-3">
            <GlassCard className="flex items-center justify-between p-4">
              <div>
                <p className="text-white font-medium">Animations</p>
                <p className="text-white/60 text-sm">Activer les animations de l'interface</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={preferences.showAnimations}
                  onChange={() => toggleSetting('showAnimations')}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-white/20 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-500"></div>
              </label>
            </GlassCard>

            <GlassCard className="flex items-center justify-between p-4">
              <div>
                <p className="text-white font-medium">Mode Réduit</p>
                <p className="text-white/60 text-sm">Réduire les mouvements pour le confort</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={preferences.reducedMotion}
                  onChange={() => toggleSetting('reducedMotion')}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-white/20 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-500"></div>
              </label>
            </GlassCard>
          </div>
        </div>

        {/* 3D Scene Settings */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 flex items-center space-x-2">
            <Eye className="w-5 h-5 text-primary-400" />
            <span>Scène 3D</span>
          </h3>
          <div className="space-y-3">
            <GlassCard className="p-4">
              <label className="block mb-2">
                <span className="text-white font-medium">Qualité de Rendu</span>
              </label>
              <select
                value={sceneSettings.quality}
                onChange={(e) => updateSceneSetting('quality', e.target.value)}
                className="glass-input w-full"
              >
                <option value="low">Basse</option>
                <option value="medium">Moyenne</option>
                <option value="high">Haute</option>
              </select>
            </GlassCard>

            <GlassCard className="p-4">
              <label className="block mb-2">
                <span className="text-white font-medium">Vitesse de Rotation</span>
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={sceneSettings.rotationSpeed}
                onChange={(e) => updateSceneSetting('rotationSpeed', parseFloat(e.target.value))}
                className="w-full h-2 bg-white/20 rounded-lg appearance-none cursor-pointer accent-primary-500"
              />
              <div className="flex justify-between text-white/60 text-sm mt-1">
                <span>Lent</span>
                <span>Rapide</span>
              </div>
            </GlassCard>
          </div>
        </div>

        {/* Media Settings */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 flex items-center space-x-2">
            <Volume2 className="w-5 h-5 text-primary-400" />
            <span>Média</span>
          </h3>
          <div className="space-y-3">
            <GlassCard className="flex items-center justify-between p-4">
              <div>
                <p className="text-white font-medium">Lecture Automatique</p>
                <p className="text-white/60 text-sm">Lecture automatique des vidéos</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={preferences.autoPlayVideos}
                  onChange={() => toggleSetting('autoPlayVideos')}
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-white/20 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-500"></div>
              </label>
            </GlassCard>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default SettingsModal

